import styled from 'styled-components';
import { variant } from 'styled-system';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { LayoutProps, PaddingProps } from '../../../../theme/styledProps';

export type SizeVariant = 'medium' | 'large';

interface ChartContainerProps {
  size: SizeVariant;
}

export const ChartContainer = styled(Box)<ChartContainerProps>(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    borderRadius: theme.radii.medium,
    paddingLeft: theme.space['8'],
    paddingRight: theme.space['8'],
    background: theme.colors.primary['500'],
  }),

  variant<LayoutProps & PaddingProps, SizeVariant>({
    prop: 'size',
    variants: {
      medium: {
        height: 24,
        pt: 4,
        pb: 4,
      },
      large: {
        height: 32,
        pt: 8,
        pb: 8,
      },
    },
  }),
);
